var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTimeCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.0955 6.7585H8.089L5.8245 6.722C5.6195 6.7185 5.4555 6.5515 5.4555 6.347V3.923C5.4555 3.716 5.6235 3.548 5.8305 3.548C6.0375 3.548 6.2055 3.716 6.2055 3.923V5.9775L8.1015 6.0085C8.3085 6.012 8.4735 6.1825 8.4705 6.3895C8.467 6.5945 8.2995 6.7585 8.0955 6.7585ZM6 1.125C3.312 1.125 1.125 3.312 1.125 6C1.125 8.688 3.312 10.875 6 10.875C8.688 10.875 10.875 8.688 10.875 6C10.875 3.312 8.688 1.125 6 1.125Z",
    fill: "#F04F4F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeCircle);
export default __webpack_public_path__ + "static/media/TimeCircle.524331befcabd3e5dcd91255cb4d8cc9.svg";
export { ForwardRef as ReactComponent };